"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.execute = exports.default = void 0;
var _UpdateNotificationsService = require("../service/UpdateNotificationsService");
var _PulseApiHelper = _interopRequireDefault(require("../service/PulseApiHelper"));
var types = _interopRequireWildcard(require("../store/actions/actionTypes"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any. The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/

/**
 * The function will toggle the read status of
 * a particular notification and return if the status
 * is successful or not.
 * @param notification
 */
const execute = notification => async dispatch => {
  dispatch({
    type: types.TOGGLE_NOTIFICATION_READ_STATUS,
    payload: {
      id: notification.id
    }
  });
  const queryObject = _PulseApiHelper.default.createANSResponseObject({
    ...notification,
    isRead: !notification.isRead
  });
  const {
    notification: notifications
  } = await (0, _UpdateNotificationsService.updateNotifications)([queryObject]);
  if (notifications.length !== 1) {
    dispatch({
      type: types.TOGGLE_NOTIFICATION_READ_STATUS,
      payload: {
        id: notification.id
      }
    });
  }
  return notifications.length === 1;
};
exports.execute = execute;
var _default = execute;
exports.default = _default;